// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// Assets
import LessThan05 from "../../../../../../../../assets/images/deviation-patterns/LessThan05.png";
import LessThan1 from "../../../../../../../../assets/images/deviation-patterns/LessThan1.png";
import LessThan2 from "../../../../../../../../assets/images/deviation-patterns/LessThan2.png";
import LessThan5 from "../../../../../../../../assets/images/deviation-patterns/LessThan5.png";

type PatternLegendType = {
  displayColumn?: boolean;
};

const PatternLegend = ({ displayColumn = true }: PatternLegendType) => (
  <Box
    display="flex"
    justifyContent={displayColumn ? "flex-start" : "center"}
    flexDirection={displayColumn ? "column" : "row"}
    columnGap={displayColumn ? "0px" : "16px"}
    rowGap={displayColumn ? "0px" : "4px"}
    width="100%"
    flexWrap="wrap"
  >
    <Box display="flex" alignItems="center" gap="8px">
      <img
        src={LessThan5}
        alt="Deviation percentile less than 5 representation"
        width="15"
        height="15"
      />
      <Typography fontSize={{ xs: "14px", sm: "12px" }} noWrap>
        {"< 5%"}
      </Typography>
    </Box>
    <Box display="flex" alignItems="center" gap="8px">
      <img
        src={LessThan2}
        alt="Deviation percentile less than 2 representation"
        width="15"
        height="15"
      />
      <Typography fontSize={{ xs: "14px", sm: "12px" }} noWrap>
        {"< 2%"}
      </Typography>
    </Box>
    <Box display="flex" alignItems="center" gap="8px">
      <img
        src={LessThan1}
        alt="Deviation percentile less than 1 representation"
        width="15"
        height="15"
      />
      <Typography fontSize={{ xs: "14px", sm: "12px" }} noWrap>
        {"< 1%"}
      </Typography>
    </Box>
    <Box display="flex" alignItems="center" gap="8px">
      <img
        src={LessThan05}
        alt="Deviation percentile less than 0.5 representation"
        width="15"
        height="15"
      />
      <Typography fontSize={{ xs: "14px", sm: "12px" }} noWrap>
        {"< 0.5%"}
      </Typography>
    </Box>
  </Box>
);

export default PatternLegend;
